import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  editorArea: {
    display: 'flex',
    paddingBottom: '10px',
  },
  thumbnailsPanel: {
    flexGrow: 0,
  },
  thumbnailsContainer: {
    height: '100%',
    borderRight: '1px solid #2C2D3E4D',
  },
  thumbnailsScroll: {
    overflow: 'auto',
    paddingLeft: '10px',
  },
  coordinatesPanel: {
    flexGrow: 2,
    paddingLeft: '20px',
  },
  coordinatesForm: {
    width: '180px',
  },
  zonesPanel: { width: '500px', backgroundColor: '#CACAFC36', padding: '15px' },
  zonesPanelScroll: {
    overflow: 'auto',
    marginRight: '0',
    display: 'flex',
    flexDirection: 'column',
    '& canvas': {
      border: 'solid 1px black',
    },
  },
  panelTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#2C2D3E',
  },
  pagePreview: {
    transition: '0.1s',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    '& img': {
      border: 'solid 1px black',
    },
    '& .ReactCrop__crop-selection': {
      border: '2px solid #3560FF',
    },
    '& .ReactCrop__drag-handle::after': {
      width: '50px',
      height: '50px',
      backgroundColor: 'transparent',
    },
    '& .ord-nw': {
      marginLeft: '-1px!important',
      marginTop: '-1px!important',
      backgroundColor: 'none!important',
    },
    '& .ord-nw::after': {
      borderLeft: 'solid 5px #3560FF',
      borderTop: 'solid 5px #3560FF',
      borderRight: 'none',
      borderBottom: 'none',
    },

    '& .ord-se': {
      marginRight: '-1px!important',
      marginBottom: '-1px!important',
    },
    '& .ord-se::after': {
      borderRight: 'solid 5px #3560FF',
      borderBottom: 'solid 5px #3560FF',
      borderLeft: 'none',
      borderTop: 'none',
    },
    '& .ord-e, & .ord-n, & .ord-w, & .ord-s, & .ord-ne, & .ord-sw': {
      display: 'none',
    },
  },
  coordinatesRow: {
    marginBottom: '20px',
    display: 'flex',
    '& .MuiFormControl-root': {
      marginRight: '20px',
    },
  },
  addZoneButton: {
    float: 'right',
    height: '30px',
    fontSize: '12px',
    backgroundColor: '#347F42',
    marginRight: '20px',
    '&:hover': {
      backgroundColor: '#035412',
    },
  },
  zonesClusterSwitchCards: {
    '& .MuiButton-label': {
      textTransform: 'none',
      padding: '0 15px 0 15px',
    },
  },
}));

export const inputProps = {
  style: {
    padding: '10px 5px 10px 10px',
    color: '#2C2D3E',
  },
};

export const inputLabelProps = {
  style: { color: '#2C2D3E' },
  shrink: true,
};
